import { API } from "./baseService";
import APP_CONST from "../../core/shared/constants";

export const doDownloadFileUrl = (data) => {
  const downloadPath = APP_CONST.API.DOCUMENT_DOWNLOAD_FILE;
  return API.post(downloadPath, data);
};
export const dodownloadDropzoneFileUrl = (data) => {
  const downloadPath = APP_CONST.API.DROPZONE_DOWNLOAD_FILE;
  return API.post(downloadPath, data);
};

export const doPassDocdetails = (data) => {
  const artifactPath = APP_CONST.API.DOCUMENT_SAVE;
  return API.post(artifactPath, data);
};

export const doCancelUpload = (data) => {
  const contextPath = `documentscreening${APP_CONST.API.CANCEL}/${data}`;
  return API.put(contextPath, data);
};

export const doScanningStatus = (fileGuid) => {
  const scanStatusPath = APP_CONST.API.SCANNING_STATUS;
  return API.get(`${scanStatusPath}/${fileGuid}`);
};

export const doPreviewFile = (data) => {
  const previewPath = APP_CONST.API.DOCUMENT_PREVIEW;
  return API.post(previewPath, data);
};

export const doCreateNewDocVersion = (data) => {
  const contextPath = APP_CONST.API.DOCUMENT_CREATE_VERSION;
  return API.post(contextPath, data);
};

export const doCancelScanning = (fileGuid) => {
  const cancelStatusPath = APP_CONST.API.DOCUMENT_CANCEL_VERSION;
  return API.put(`${cancelStatusPath}/${fileGuid}`);
};